const DEFAULT_COVER_LETTER_PARAGRAPH_1 =
  "On behalf of the Board of Directors and Regional Councils, I would like to thank you for your firm's participation in World Services Group during this past year. In the enclosed email, you will find your Membership Activity Summary based on group involvement, meeting attendance, news, content automation, referral submissions, membership engagement and more. We look forward to continuing to work with you and your partners to create more business opportunities for your firm.";

const DEFAULT_COVER_LETTER_PARAGRAPH_2 =
  "Over the past year, WSG has continued to strengthen the membership through the member relationship program including creating better collaboration opportunities and integration with member marketing and business development departments. The WSG next generation platform is now built on cutting edge Microsoft Azures technology and Cosmos database. The platform includes a growing number of technology-driven tools and resources to allow firms to best leverage their membership, and most importantly will offer the network limitless scalability ensuring optimal performance for the future. These initiatives have offered great value during these unprecedented times and make WSG a source of leading industry insight. In effort build upon the network's success as the globally recognized premier network, the Board of Directors resolved to approve the renewal of the Development Fund and a standard inflation adjustment of 4% for the coming year.";

const DEFAULT_COVER_LETTER_PARAGRAPH_3 =
  "Should you have any invoice questions, please contact me or Maricarmen Trujillo, Chief Operating Officer, at mtrujillo@worldservicesgroup.com, 713-650-0333.";

/** Default cover letter paragraphs joined with blank lines (textarea preload format). */
export function buildDefaultCoverLetterBody(
  _subject?: string,
  _recipientName?: string,
): string {
  return [
    DEFAULT_COVER_LETTER_PARAGRAPH_1,
    DEFAULT_COVER_LETTER_PARAGRAPH_2,
    DEFAULT_COVER_LETTER_PARAGRAPH_3,
  ].join("\n\n");
}

/** Split cover letter body into paragraphs (blank-line separated). */
export function splitCoverLetterBody(text: string): string[] {
  return text
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}

export function buildDefaultCoverLetterParagraphs(
  subject?: string,
  recipientName?: string,
): string[] {
  return splitCoverLetterBody(
    buildDefaultCoverLetterBody(subject, recipientName),
  );
}

export function resolveCoverLetterBodyParagraphs({
  savedBody,
  subject,
  recipientName,
}: {
  savedBody?: string | null;
  subject: string;
  recipientName: string;
}): string[] {
  const trimmed = (savedBody ?? "").trim();
  if (trimmed) {
    return splitCoverLetterBody(trimmed);
  }
  return buildDefaultCoverLetterParagraphs(subject, recipientName);
}
